<template lang="pug">
.status-wrapper
  .container(v-if="!empty || loading")
    .rule(@click="goRule()") 规则
    template(v-for="module in modules")
      template(v-if="module === CARD_MODULE_B.market_sale")
        .banner
          img.banner-pic(
            src="https://m.hellobike.com/resource/AppPlatformH5/card-for-app/aCYLOlopbxSV46OpGTpr1.png"
          )
      template(v-if="loading || showBikePart")
        template(v-if="module === CARD_MODULE_B.market_bike_header")
          .tw-title
            .big 单车卡券 1折起
            .small 哈啰APP专享
        template(
          v-if="module === CARD_MODULE_B.market_bike_card && module.length > 0"
        )
          CardModule.module(:data="bikeCards", :loading="cardLoading")
        template(v-if="module === CARD_MODULE_B.market_bike_coupon")
          CouponModule.module(:data="bikeCoupons", :loading="loading")
      template(v-if="loading || showEbikePart")
        template(v-if="module === CARD_MODULE_B.market_evBike_header")
          .tw-title
            .big 助力车卡券 1折起
            .small 哈啰APP专享
        template(v-if="module === CARD_MODULE_B.market_evBike_card")
          CardModule.module(:data="ebikeCards", :loading="cardLoading")
        template(v-if="module === CARD_MODULE_B.market_evBike_coupon")
          CouponModule.module(:data="ebikeCoupons", :loading="loading")
      template(v-if="module === CARD_MODULE_B.market_banner")
        .discount-module.module(@click="goDiscount")
          .left.flex-mid
            img(
              src="https://m.hellobike.com/resource/AppPlatformH5/common/3N2q-pGdEG71G5XFaAVP6.png"
            )
          .mid
            .title
              span APP骑行
              span.color 单单随机立减
            .subtitle
              span APP骑行首单 最高享免单
          .right.flex-mid
            .discount-btn.flex-mid
              span 去领取
              span.arrow
    .download(v-if="!isApp", @click="goDownload")
      img.hello(
        src="https://m.hellobike.com/resource/helloyun/07177/mx8ZuXSCbe.png?x-oss-process=image/quality,q_80"
      )
      .text 立即下载哈啰APP
  EmptyState(
    v-else,
    :text="emptytext",
    @click="clickEmpty",
    :btntext="emptybtntext"
  )
</template>
<script>
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { startApp } from '@/utils/index';
import { formatCardTags } from '@/utils/card';
import { getCardPageModule, getTWCards } from '@/api/card';
import ComingSoon from './components/coming-soon'; // 敬请期待
import config from '../../const/config';
import CardModule from './components/card-module';
import CouponModule from './components/coupon-module';
import EmptyState from './empty-state';
import { CARD_MODULE_B, getPageBPort } from './utils';
import {
  getTokenAndLocation,
  getTWCardPlatform,
  isPreRender,
  sub,
  tryCatch,
} from '../../utils';
import { getVersion } from '../../utils/systemCode';
import { ParamsUtil } from '../../utils/params';

const DEFAULT_MODULES = () => [
  CARD_MODULE_B.market_sale, // 大促模块
  CARD_MODULE_B.market_bike_header, // 单车标题
  CARD_MODULE_B.market_bike_card, // 单车卡
  CARD_MODULE_B.market_bike_coupon, // 单车券
  CARD_MODULE_B.market_evBike_header, // 助力车标题
  CARD_MODULE_B.market_evBike_card, // 助力车卡
  CARD_MODULE_B.market_evBike_coupon, // 助力车券
  CARD_MODULE_B.market_banner,
];

const CouponMapper = (businessType) => (item) => {
  UBT.moduleExpose({
    pageId: 'APP_exclusive',
    categoryId: 'platform',
    moduleId: 'APP_bikecoupon',
    contentId: 'APP_bikecoupon',
    exposureTimes: 1,
    businessInfo: {
      commodity_name: item.goodsName,
      business: businessType,
    },
  });
  return {
    name: item.goodsName,
    businessType,
    subtitle: `${item.originalPrice}元券包`,
    originPrice: item.originalPrice,
    purchasePrice: item.salePrice,
    amount: (item.propertyDetailList || []).reduce(
      (res, { virtualNum }) => res + virtualNum,
      0,
    ),
    url: item.goodsDetailUrl,
    detail: item,
  };
};

const CardMapper = (p) => {
  const { shelfGuid, businessType, channelCode } = p;
  const params = {
    shelfGuid,
    businessType,
    channelCode,
    actionOrigin: 'PlatformSellingCard',
  };
  return p.packages.map((item) => {
    const {
      showName,
      originPrice,
      cardBatchInfo,
      actualPrice,
      paymentLimit,
      purchasePrice,
    } = item;
    const currentPrice = tryCatch(() => actualPrice.finalPrice, purchasePrice);
    const isAppOnly = tryCatch(() => cardBatchInfo.usePlatform === 0, false);
    UBT.moduleExpose({
      pageId: 'APP_exclusive',
      categoryId: 'platform',
      moduleId: 'APP_bikecard',
      contentId: 'APP_bikecard',
      exposureTimes: 1,
      businessInfo: {
        card_name: showName,
        business: businessType,
      },
    });
    return {
      title: showName,
      originPrice,
      corner: isAppOnly ? 'APP专享' : '',
      isAppOnly,
      currentPrice,
      businessType,
      subtitle:
        Number(paymentLimit) === 1
          ? `续费${purchasePrice}元/月，可随时取消`
          : '',
      diff: String(sub(originPrice, currentPrice)),
      detail: item,
      isCard: true,
      marketingWords: formatCardTags(item) || [],
      days: tryCatch(() => cardBatchInfo.effectDay, null),
      params,
      paymentLimit,
      btn: '购买',
    };
  })
    .filter((item) => {
      if (env.isWechatMini) {
        return item.paymentLimit !== 1 && item.isAppOnly;
      }
      return item.isAppOnly;
    });
};

export default {
  name: 'PageB',
  components: {
    CardModule,
    CouponModule,
    ComingSoon,
    EmptyState,
  },
  data() {
    return {
      modules: DEFAULT_MODULES(), // 模块key
      CARD_MODULE_B,
      loading: true,
      cardLoading: true,
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true',
        ruleLink:
          'https://h.c3x.me/1Guq79',
        status: true,
      },
      env: process.env.VUE_APP_ENV,
      isApp: env.isEasyBikeApp,
      bikeCoupons: null,
      ebikeCoupons: null,
      bikeCards: null,
      ebikeCards: null,
    };
  },
  computed: {
    showBikePart() {
      return (
        (this.bikeCards && this.bikeCards.length > 0)
        || (this.bikeCoupons && this.bikeCoupons.length > 0)
      );
    },
    showEbikePart() {
      return (
        (this.ebikeCards && this.ebikeCards.length > 0)
        || (this.ebikeCoupons && this.ebikeCoupons.length > 0)
      );
    },
    empty() {
      return (
        (!this.ebikeCards || this.ebikeCards.length === 0)
        && (!this.bikeCards || this.bikeCards.length === 0)
        && (!this.bikeCoupons || this.bikeCoupons.length === 0)
        && (!this.ebikeCoupons || this.ebikeCoupons.length === 0)
      );
    },
    // 空态页数据
    emptytext() {
      return this.isApp
        ? '去福利中心逛逛，查看更多优惠信息'
        : '去下载哈啰APP，查看更多优惠';
    },
    emptybtntext() {
      return this.isApp ? '去福利中心' : '下载哈啰';
    },
  },
  created() {
    const { source, adsource } = this.$route.query;
    this.source = source || adsource;
    UBT.pageView({
      pageId: 'APP_exclusive',
      categoryId: 'platform',
      businessInfo: {
        port: getPageBPort(),
        source: this.source,
        adsource: this.source,
      },
    });
  },
  mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    this.bizLogic();
  },
  methods: {
    // app随机立减领取
    async goDiscount() {
      const url = `https://m.hellobike.com/AppPlatformH5/${
        config.env !== 'pro' ? `${config.env}/` : ''
      }latest/pr_index_discount.html#/discount`;
      window.location.href = ParamsUtil.addParams(url, await getTokenAndLocation() || {});
    },
    // 点击下载app
    goUrl(url = this.config.deepLink, download = false) {
      UBT.clickButton({
        pageId: 'APP_exclusive',
        buttonName: 'Down_app',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      window.location.href = url;
    },
    clickEmpty() {
      UBT.clickButton({
        pageId: 'platform_none',
        buttonName: 'APP_go',
        categoryId: 'platform',
        businessInfo: {
          port: getPageBPort(),
        },
      });
      if (env.isWechatMini) {
        window.location.href = 'https://h.c3x.me/1G7IhQ';
        return;
      }
      let url = 'https://m.hellobike.com/h5-activity/latest/activity20210408113040038675.html';
      if (env.isEasyBikeApp) {
        url = `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/bounty`;
      }
      window.location.href = url;
    },
    goDownload() {
      if (env.isWechatMini) {
        window.location.href = 'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280';
        return;
      }
      this.goUrl(this.config.deepLink, true);
    },
    goRule() {
      UBT.clickButton({
        pageId: 'APP_exclusive',
        buttonName: 'APP_rule',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.goUrl(this.config.ruleLink);
    },
    handleCoupons(moduleData) {
      if (!moduleData || !moduleData[0] || !moduleData[0].data) {
        return;
      }
      const {
        market_bike_coupon: bike,
        market_evBike_coupon: ebike,
      } = moduleData[0].data;
      if (bike && bike.length) {
        this.bikeCoupons = bike.map(CouponMapper(1));
      }
      if (ebike && ebike.length) {
        this.ebikeCoupons = ebike.map(CouponMapper(2));
      }
    },
    handleCards(packages) {
      if (!packages || !packages.length) {
        return;
      }
      packages.forEach((p) => {
        if (p.businessType === 1) {
          this.bikeCards = CardMapper(p);
        } else if (p.businessType === 2) {
          this.ebikeCards = CardMapper(p);
        }
      });
    },
    // 初始化事件
    async bizLogic() {
      const { cityCode, adCode, token } = await getTokenAndLocation();
      const data = await getCardPageModule({
        pageType: 18,
        cityCode,
        adCode,
        token,
      })
        .then((v) => tryCatch(() => v.data.moduleList, null))
        .catch(() => null);
      if (!data) {
        this.loading = false;
        this.cardLoading = false;
        return;
      }
      const {
        modules, couponData, bikeCard, ebikeCard,
      } = data.reduce(
        (res, m) => {
          res.modules.push(m.moduleKey);
          if (m.moduleKey === CARD_MODULE_B.market_bike_card) {
            res.bikeCard = true;
          } else if (m.moduleKey === CARD_MODULE_B.market_evBike_card) {
            res.ebikeCard = true;
          } else if (
            m.moduleKey === CARD_MODULE_B.market_evBike_coupon
            || m.moduleKey === CARD_MODULE_B.market_bike_coupon
          ) {
            res.couponData = m.moduleData;
          }
          return res;
        },
        {
          modules: [],
          couponData: null,
          bikeCard: false,
          ebikeCard: false,
        },
      );

      this.modules = modules;
      if (couponData) {
        this.handleCoupons(couponData);
      }
      const channelCodes = [];
      if (bikeCard) {
        channelCodes.push(101010);
      }
      if (ebikeCard) {
        channelCodes.push(102010);
      }
      if (channelCodes.length === 0) {
        this.cardLoading = false;
        this.loading = false;
        return;
      }
      getTWCards({
        token,
        adCode,
        cityCode,
        channelCodes,
        platform: getTWCardPlatform(),
        version: await getVersion(),
      })
        .then((res) => tryCatch(() => res.data.packageGroups), null)
        .catch(() => null)
        .then((packages) => {
          if (packages) {
            this.handleCards(packages);
          }
          this.cardLoading = false;
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.arrange {
  display: flex;
  flex-wrap: wrap;
}

.status-wrapper {
  height: 100vh;
}

.container {
  font-size: 20px;
  width: 100%;
  overflow-y: scroll;
  min-height: 100vh;
  background: #ff3e15;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
    color: transparent;
  }

  .rule {
    position: absolute;
    top: 0.22rem;
    right: 0;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.3);
    border-top-left-radius: 0.12rem;
    border-bottom-left-radius: 0.12rem;
    padding-left: 0.12rem;
    justify-content: space-between;
    font-size: 0.12rem;
    color: white;
    width: 0.48rem;
    height: 0.24rem;
    display: flex;
    align-items: center;

    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      right: 5px;
      width: 0.08rem;
      height: 0.08rem;
      border-bottom: 0.02rem solid white;
      border-right: 0.02rem solid white;
      transform: translateY(-50%) rotate(-45deg) scale(0.7);
    }
  }

  .banner-pic {
    width: 100%;
    height: 1.97rem;
  }

  .tw-title {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-content: center;

    .big {
      margin-top: 0.2rem;
      height: 0.3rem;
      font-size: 0.2rem;
      font-weight: 500;
      color: #fff;
      line-height: 0.28rem;

      &::before {
        content: "";
        display: inline-block;
        margin-right: 0.04rem;
        width: 0.29rem;
        height: 0.16rem;
        background-image: url("https://m.hellobike.com/resource/AppPlatformH5/card-for-app/6-x4-7QsoN1yBXjYe8CaB.png");
        background-size: 100%;
      }

      &::after {
        content: "";
        display: inline-block;
        margin-left: 0.04rem;
        width: 0.29rem;
        height: 0.16rem;
        background-image: url("https://m.hellobike.com/resource/AppPlatformH5/card-for-app/u7IuFMook8AEpDapPNcoD.png");
        background-size: 100%;
      }
    }

    .small {
      height: 0.2rem;
      font-size: 0.14rem;
      font-weight: 200;
      color: #fff;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;
      opacity: 0.9;
    }
  }

  .module {
    width: 3.51rem;
    background: #fff;
    border-radius: 0.12rem;
    margin: 0 auto 0.08rem;
  }

  .ticket {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 1.58rem;
    padding-top: 0.2rem;
    padding-bottom: 0.16rem;
    box-sizing: border-box;
    overflow-x: scroll;
    overflow-y: hidden;

    .ticket-wrapper {
      display: flex;
      justify-content: space-around;
    }
  }

  .discount-module {
    min-height: 0.84rem;
    background: white;
    border-radius: 0.08rem;
    height: 0.8rem;
    padding: 0.1rem 0.18rem 0.1rem 0.16rem;
    display: flex;
    justify-content: space-between;
    font-size: 0.12rem;
    position: relative;
    // white-space: nowrap;
    .left {
      img {
        width: 0.58rem;
        height: 0.43rem;
      }
    }

    .mid {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      white-space: nowrap;
      flex: 1;
      margin-left: 0.1rem;

      .title {
        display: flex;
        flex-direction: row;
        font-size: 0.16rem;
        font-weight: 500;
        margin-bottom: 2px;
        white-space: nowrap;

        .color {
          color: rgba(255, 86, 0, 1);
        }
      }

      .subtitle {
        display: flex;
        flex-direction: column;
        color: rgba(130, 140, 153, 1);
        font-size: 0.12rem;
        white-space: nowrap;
      }
    }

    .right {
      .discount-btn {
        width: 0.72rem;
        height: 0.26rem;
        background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
        border-radius: 0.16rem;
        font-size: 0.12rem;
        font-weight: 500;
        color: #fff;

        .arrow {
          width: 0.06rem;
          height: 0.06rem;
          border-bottom: 1px solid white;
          border-right: 1px solid white;
          transform: rotateZ(-45deg);
        }
      }
    }
  }

  .download {
    display: flex;
    justify-content: center;
    padding-top: 0.24rem;
    padding-bottom: 0.2rem;
    align-items: center;
    position: relative;
    z-index: 10;

    .hello {
      width: 0.16rem;
      height: 0.16rem;
      border-radius: 0.02rem;
      margin-right: 0.07rem;
    }

    .text {
      font-size: 0.12rem;
      font-weight: 400;
      color: #fdfeff;
      line-height: 0.17rem;
      position: relative;

      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 50%;
        right: -0.1rem;
        width: 0.08rem;
        height: 0.08rem;
        border-bottom: 0.02rem solid white;
        border-right: 0.02rem solid white;
        transform: translateY(-50%) rotate(-45deg) scale(0.7);
      }
    }
  }
}
</style>
